import { skipToken } from '@reduxjs/toolkit/query';
import { useGetAttachmentsQuery } from '../api';

type UseAttachmentsOptions = {
  campaignId: number;
  skipRequest?: boolean;
};

export const useAttachments = (options: UseAttachmentsOptions) => {
  const { data: attachmentsResponse, isFetching } = useGetAttachmentsQuery(
    options.skipRequest ? skipToken : options.campaignId
  );

  return {
    attachments: attachmentsResponse?.data.attachments ?? [],
    isFetching,
  };
};
